module.exports = __webpack_public_path__ + "img/tgicon.7957e04f.png";